import { iDataSchemas } from '../interfaces/iDataSchema'

export const calculateEnumPaths = (items: iDataSchemas, parentPath = '') => {
  let ret: string[] = []

  Object.entries(items).forEach(([name, child]) => {
    const scope = (parentPath ?  parentPath + '.' : '') + name
    if (child.enum && 'key' in child.enum) {
      ret.push(scope)
    }
    if (child.properties) {
      const childScopes = calculateEnumPaths(child.properties, scope)
      ret.push(...childScopes)
    } else if (child.items?.properties) {
      const childScopes = calculateEnumPaths(child.items.properties, scope +'.[]')
      ret.push(...childScopes)
    }
  })
  return ret
}
